import Highlighter from "react-highlight-words"
import useTranslations from "hooks/useTranslations"
import { EnvelopeIcon } from "@heroicons/react/24/outline"
import ImageTeamMember from "components/ImageTeamMember"
import ContentPageContainer from "components/molecules/common/ContentPageContainer"

const Section = ({
  name,
  highlight,
  title,
  image,
  position,
  email,
  id,
  description,
}) => {
  return (
    <div className="flex flex-col items-start space-y-6 py-10" id={id}>
      <h2 className="mb-0 grow text-left text-2xl text-zinc-800">
        <Highlighter
          highlightClassName="font-bold underline bg-transparent text-kkm-darkgreen"
          searchWords={highlight || [""]}
          autoEscape
          textToHighlight={title}
        />
      </h2>
      <p className="mb-0 grow whitespace-pre-line text-left font-body text-base text-zinc-800">
        {description}
      </p>
      <div className="flex items-center space-x-4 lg:space-x-6">
        <ImageTeamMember
          className="w-16 lg:w-20"
          imgClassName="rounded-full"
          filename={image}
          alt={name}
        />
        <div className="space-y-1">
          <p className="m-0 font-display text-lg text-zinc-800">{name}</p>
          <p className="m-0 font-display text-sm text-kkm-darkgreen">
            {position}
          </p>
          <p className="font-text m-0 inline-block text-sm text-zinc-800">
            <a href={`mailto:${email}`} onClick={(e) => e.preventDefault}>
              <EnvelopeIcon className="mr-1 inline-block w-5 text-kkm-darkgreen" />
              {email}
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default function Protected() {
  const {
    protectionPreventShort,
    protectionPreventLong,
    protectionPreventContactName,
    protectionPreventContactPosition,
    protectionPreventContactEmail,
    protectionProtectShort,
    protectionProtectLong,
    protectionProtectContactName,
    protectionProtectContactPosition,
    protectionProtectContactEmail,
    protectionImpactShort,
    protectionImpactLong,
    protectionImpactContactName,
    protectionImpactContactPosition,
    protectionImpactContactEmail,
    protectionPreventHighlight,
    protectionProtectHighlight,
    protectionImpactHighlight,
    protectionTitle,
    protectionReadMore,
  } = useTranslations()
  const features = [
    {
      id: 1,
      name: protectionPreventContactName,
      position: protectionPreventContactPosition,
      email: protectionPreventContactEmail,
      image: "suvi-square.jpg",
      highlight: protectionPreventHighlight,
      title: protectionPreventShort,
      description: protectionPreventLong,
    },
    {
      id: 2,
      name: protectionProtectContactName,
      position: protectionProtectContactPosition,
      email: protectionProtectContactEmail,
      image: "kaisa-square.jpg",
      highlight: protectionProtectHighlight,
      title: protectionProtectShort,
      description: protectionProtectLong,
    },
    {
      id: 3,
      name: protectionImpactContactName,
      position: protectionImpactContactPosition,
      email: protectionImpactContactEmail,
      image: "kati-nevatalo-square.jpg",
      highlight: protectionImpactHighlight,
      title: protectionImpactShort,
      description: protectionImpactLong,
    },
  ]

  return (
    <ContentPageContainer title={protectionTitle}>
      {features.map((item) => (
        <Section {...item} key={item.id} readMore={protectionReadMore} />
      ))}
    </ContentPageContainer>
  )
}
